import React, { useContext, useEffect } from 'react'
import { Button, Grid, Hidden, Typography, useMediaQuery, } from '@mui/material'
import { useNavigate } from 'react-router';

const Register = ({ IsPreview }) => {
    const navigate = useNavigate();
    const onGotoPage = () => navigate("/ApplyMember");
    const LayoutWeb = useMediaQuery('(min-width:1180px)');
    const LayoutiPad = useMediaQuery('(min-width:820px)');
    const LayoutPhone = useMediaQuery('(min-width:930px)');
    return (
        <React.Fragment>
            {/* normal size */}
            {LayoutWeb ? (
                <Grid container alignItems='center' >
                    <Grid item xs={12} sm={12} md={6}>
                        <div className='session-b-left'>
                            <div className='session-b-text'>
                                <Typography className='session-b-title'>ประวัติความเป็นมา</Typography>
                                <Typography className='session-b-detail' sx={{ whiteSpace: 'pre-line' }}>
                                    กองทุนจัดการซากดึกดำบรรพ์เป็นมาตรการทางการเงินที่จัดตั้งขึ้นในกรมทรัพยากรธรณี โดยอาศัยอำนาจตามความในพระราชบัญญัติคุ้มครองซากดึกดำบรรพ์ พ.ศ. 2551 หมวด 5 กองทุนจัดการซากดึกดำบรรพ์ มาตรา 38 ถึงมาตรา 46 (ภาคผนวก ก) เพื่อเป็นทุนสำหรับใช้จ่ายในการสนับสนุนและส่งเสริมการศึกษาวิจัย การอนุรักษ์ การพัฒนาบริหารจัดการ แหล่งซากดึกดำบรรพ์การรวบรวมและจัดเก็บหลักฐานทางธรณีวิทยาและธรรมชาติวิทยาและเก็บรักษาซากดึกดำบรรพ์ มีกรมทรัพยากรธรณีโดยกองคุ้มครองซากดึกดำบรรพ์เป็นหน่วยบริหารงานกองทุนจัดการซากดึกดำบรรพ์ ภายใต้การกำกับดูแลของคณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์ คณะกรรมการติดตามและประเมินผลการดำเนินงานของกองทุนจัดการซากดึกดำบรรพ์และคณะกรรมการคุ้มครองซากดึกดำบรรพ์
                                </Typography>
                            </div>

                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={6}>
                        <div className='session-b-right'>
                            <div className='session-b-btn-register'>
                                {!IsPreview && <Button variant="contained" onClick={() => onGotoPage()} >คลิกเพื่อสมัครเข้าใช้งานระบบ</Button>}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            ) : (
                < Grid container alignItems='center' >
                    <Grid item xs={12} sm={12}>
                        <div className={LayoutPhone ? 'session-b-left-phone' : LayoutiPad ? 'session-b-left-phone1' : 'session-b-left-phone'}>
                            <div className='session-b-text-phone'>
                                <Typography className={LayoutPhone ? 'session-b-title-phone' : LayoutiPad ? 'session-b-title-phone1' : 'session-b-title-phone'}>ประวัติความเป็นมา</Typography>
                                <Typography className={LayoutPhone ? 'session-b-detail-phone' : LayoutiPad ? 'session-b-detail-phone1' : 'session-b-detail-phone'} sx={{ whiteSpace: 'pre-line' }}>
                                    กองทุนจัดการซากดึกดำบรรพ์เป็นมาตรการทางการเงินที่จัดตั้งขึ้นในกรมทรัพยากรธรณี โดยอาศัยอำนาจตามความในพระราชบัญญัติคุ้มครองซากดึกดำบรรพ์ พ.ศ. 2551 หมวด 5 กองทุนจัดการซากดึกดำบรรพ์ มาตรา 38 ถึงมาตรา 46 (ภาคผนวก ก) เพื่อเป็นทุนสำหรับใช้จ่ายในการสนับสนุนและส่งเสริมการศึกษาวิจัย การอนุรักษ์ การพัฒนาบริหารจัดการ แหล่งซากดึกดำบรรพ์การรวบรวมและจัดเก็บหลักฐานทางธรณีวิทยาและธรรมชาติวิทยาและเก็บรักษาซากดึกดำบรรพ์ มีกรมทรัพยากรธรณีโดยกองคุ้มครองซากดึกดำบรรพ์เป็นหน่วยบริหารงานกองทุนจัดการซากดึกดำบรรพ์ ภายใต้การกำกับดูแลของคณะกรรมการบริหารกองทุนจัดการซากดึกดำบรรพ์ คณะกรรมการติดตามและประเมินผลการดำเนินงานของกองทุนจัดการซากดึกดำบรรพ์และคณะกรรมการคุ้มครองซากดึกดำบรรพ์
                                </Typography>
                            </div>

                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} >
                        <div className={LayoutPhone ? 'session-b-right-phone' : LayoutiPad ? 'session-b-right-phone1' : 'session-b-right-phone'}>
                            <div className={LayoutPhone ? 'session-b-btn-register' : LayoutiPad ? 'session-b-btn-register-ipad' : 'session-b-btn-register'} >
                                {!IsPreview && <Button variant="contained" onClick={() => onGotoPage()} >คลิกเพื่อสมัครเข้าใช้งานระบบ</Button>}
                            </div>
                        </div>
                    </Grid>
                </Grid>
            )
            }
        </React.Fragment >
    )
}

export default Register

